import { Component } from "react"
import PropTypes from "prop-types"
import { keysIn } from "lodash"
import { Accordion, AccordionSummary, AccordionDetails, Tabs, Tab, Badge, Paper, IconButton, Card } from "@mui/material"
import { Close, ExpandMore } from "@mui/icons-material"
import Constraints from "./components/constraints"
import General from "./components/general"
import Factors from "./components/factors"
import "./style.scss"

function renderTab(label, value, errors) {
  if (value > 0 || errors) {
    const color = errors ? "error" : "secondary"
    const content = errors ? "!" : value
    label = <Badge overlap="rectangular" color={color} classes={{ badge: "badge" }} badgeContent={content}>
      {label}
    </Badge>
  }

  return <Tab label={label} />
}
export default class OptimizationSettings extends Component {
  static propTypes = {
    constraints: PropTypes.object,
    portfolioType: PropTypes.string.isRequired,
    factorsErrors: PropTypes.bool.isRequired,
    constraintsErrors: PropTypes.bool.isRequired,
    numberOfCurrentConstraints: PropTypes.number.isRequired,
    numberOfCurrentExposure: PropTypes.number.isRequired,
    reversedActions: PropTypes.bool,
    noCollapse: PropTypes.bool,
    closeSettings: PropTypes.func,
    defaultTab: PropTypes.number,
    resetSettings: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)

    let selectedTab = props.defaultTab

    if (selectedTab === undefined || selectedTab > 2) {
      selectedTab = null
    }

    if (props.constraints) {
      if (keysIn(props.constraints.general).length > 0) {
        selectedTab = 1
      } else if (props.constraints.exposure.length > 0) {
        selectedTab = 2
      }
    }

    this.state = { selectedTab }
  }

  onPanelExpanded = (_, expanded) => {
    if (!expanded && !this.props.noCollapse) {
      this.setState({ selectedTab: null })
    } else {
      this.setState({ selectedTab: 0 })
    }
  }

  onTabChanged = (event, value) => {
    event.stopPropagation()
    this.setState(state => {
      if (state.selectedTab === value && !this.props.noCollapse) {
        return { selectedTab: null }
      } else {
        return { selectedTab: value }
      }
    })
  }

  resetSettings = () => {
    const { resetSettings } = this.props
    resetSettings()
  }

  render() {
    const { factorsErrors, constraintsErrors, numberOfCurrentConstraints, numberOfCurrentExposure, reversedActions, noCollapse, closeSettings } = this.props
    const tabs = <Tabs value={this.state.selectedTab} onChange={this.onTabChanged} indicatorColor="primary" textColor="primary">
      <Tab label="Forecast" />
      {renderTab("Constraints", numberOfCurrentConstraints, constraintsErrors)}
      {renderTab("Factor Targets", numberOfCurrentExposure, factorsErrors)}
    </Tabs>

    const content = <>
      {this.state.selectedTab === 0 && <General {...this.props} resetSettings={this.resetSettings} reversedActions={reversedActions} />}
      {this.state.selectedTab === 1 && <Constraints {...this.props} reversedActions={reversedActions} />}
      {this.state.selectedTab === 2 && <Factors {...this.props} reversedActions={reversedActions} />}
    </>

    if (noCollapse) {
      return <div className="components_optimization-settings no-collapse">
        <Paper className="header" square>
          {tabs}
          <IconButton className="close-button" onClick={closeSettings} size="large"><Close /></IconButton>
        </Paper>
        <Card square className="settings-panel">{content}</Card>
      </div>
    }

    return <div className="components_optimization-settings">
      <Accordion onChange={this.onPanelExpanded} expanded={this.state.selectedTab !== null}>
        <AccordionSummary className="header" expandIcon={<ExpandMore />}>{tabs}</AccordionSummary>
        <AccordionDetails className="settings-panel">{content}</AccordionDetails>
      </Accordion>
    </div>
  }
}
